import Button from "@pathwright/ui/src/components/button/Button"
import SubmitButton from "@pathwright/ui/src/components/button/SubmitButton"
import Text from "@pathwright/ui/src/components/ui/Text"
import PropTypes from "prop-types"
import { useState } from "react"
import styled from "styled-components"
import { useEditPathContext } from "./EditPath"

const Overlay = styled.div`
  z-index: 9001;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 40px;
  padding: 10px 15px;
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0.8);
`

const EditPathDeleteItem = ({ pathItem }) => {
  const [submitting, setSubmitting] = useState(false)
  const { deletePathItem, setArchivingId, archivingId, handleChange } =
    useEditPathContext()

  const confirm = () => {
    setSubmitting(true)
    deletePathItem(pathItem).finally(() => {
      setArchivingId(null)
      // alert parent (legacy/client) that changes have occurred.
      handleChange()
    })
  }

  if (archivingId !== pathItem.id) {
    return null
  }

  return (
    <Overlay>
      <div>
        <Text.H5 inverted>
          Remove <em>{pathItem.name}</em>?
        </Text.H5>
        {pathItem.type === "step" && (
          <Text.Meta inverted>
            This will also archive any discussions and attachments associated
            with this {pathItem.type}.
          </Text.Meta>
        )}
      </div>
      <div>
        <SubmitButton submitting={submitting} onClick={confirm} dangerous>
          Yes, Remove
        </SubmitButton>
        <Button onClick={() => setArchivingId(null)} styleType="blank" inverted>
          Cancel
        </Button>
      </div>
    </Overlay>
  )
}

EditPathDeleteItem.displayName = "EditPathDeleteItem"

EditPathDeleteItem.propTypes = {
  pathItem: PropTypes.object.isRequired
}

export default EditPathDeleteItem
